import * as w from "react";
import Y from "react";
import { s as T } from "./styled-38387a7e.js";
import { g as G, u as D, c as S } from "./useThemeProps-ee4acb93.js";
import { g as H, a as U, _ as l, b as I, p as o, c as j } from "./createTheme-02ce03eb.js";
import { j as d, c as E } from "./useTheme-efe1290c.js";
import { u as Z } from "./useControlled-cc2d41cb.js";
import { i as k } from "./integerPropType-e817878c.js";
import { u as aa } from "./useTheme-d46e2483.js";
import { c as _ } from "./createSvgIcon-9d6f669e.js";
import { B as ta } from "./ButtonBase-a4bd3410.js";
function oa(a) {
  return H("MuiPagination", a);
}
G("MuiPagination", ["root", "ul", "outlined", "text"]);
const ea = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
function sa(a = {}) {
  const {
    boundaryCount: t = 1,
    componentName: e = "usePagination",
    count: s = 1,
    defaultPage: f = 1,
    disabled: b = !1,
    hideNextButton: y = !1,
    hidePrevButton: r = !1,
    onChange: u,
    page: x,
    showFirstButton: O = !1,
    showLastButton: M = !1,
    siblingCount: m = 1
  } = a, c = U(a, ea), [i, B] = Z({
    controlled: x,
    default: f,
    name: e,
    state: "page"
  }), z = (n, C) => {
    x || B(C), u && u(n, C);
  }, g = (n, C) => {
    const Q = C - n + 1;
    return Array.from({
      length: Q
    }, (Pa, X) => n + X);
  }, N = g(1, Math.min(t, s)), v = g(Math.max(s - t + 1, t + 1), s), L = Math.max(
    Math.min(
      // Natural start
      i - m,
      // Lower boundary when page is high
      s - t - m * 2 - 1
    ),
    // Greater than startPages
    t + 2
  ), $ = Math.min(
    Math.max(
      // Natural end
      i + m,
      // Upper boundary when page is low
      t + m * 2 + 2
    ),
    // Less than endPages
    v.length > 0 ? v[0] - 2 : s - 1
  ), R = [
    ...O ? ["first"] : [],
    ...r ? [] : ["previous"],
    ...N,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...L > t + 2 ? ["start-ellipsis"] : t + 1 < s - t ? [t + 1] : [],
    // Sibling pages
    ...g(L, $),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...$ < s - t - 1 ? ["end-ellipsis"] : s - t > t ? [s - t] : [],
    ...v,
    ...y ? [] : ["next"],
    ...M ? ["last"] : []
  ], h = (n) => {
    switch (n) {
      case "first":
        return 1;
      case "previous":
        return i - 1;
      case "next":
        return i + 1;
      case "last":
        return s;
      default:
        return null;
    }
  }, P = R.map((n) => typeof n == "number" ? {
    onClick: (C) => {
      z(C, n);
    },
    type: "page",
    page: n,
    selected: n === i,
    disabled: b,
    "aria-current": n === i ? "true" : void 0
  } : {
    onClick: (C) => {
      z(C, h(n));
    },
    type: n,
    page: h(n),
    selected: !1,
    disabled: b || n.indexOf("ellipsis") === -1 && (n === "next" || n === "last" ? i >= s : i <= 1)
  });
  return l({
    items: P
  }, c);
}
function na(a) {
  return H("MuiPaginationItem", a);
}
const ia = G("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon"]), p = ia, W = _(/* @__PURE__ */ d.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), A = _(/* @__PURE__ */ d.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), F = _(/* @__PURE__ */ d.jsx("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), V = _(/* @__PURE__ */ d.jsx("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), ra = ["className", "color", "component", "components", "disabled", "page", "selected", "shape", "size", "slots", "type", "variant"], q = (a, t) => {
  const {
    ownerState: e
  } = a;
  return [t.root, t[e.variant], t[`size${j(e.size)}`], e.variant === "text" && t[`text${j(e.color)}`], e.variant === "outlined" && t[`outlined${j(e.color)}`], e.shape === "rounded" && t.rounded, e.type === "page" && t.page, (e.type === "start-ellipsis" || e.type === "end-ellipsis") && t.ellipsis, (e.type === "previous" || e.type === "next") && t.previousNext, (e.type === "first" || e.type === "last") && t.firstLast];
}, la = (a) => {
  const {
    classes: t,
    color: e,
    disabled: s,
    selected: f,
    size: b,
    shape: y,
    type: r,
    variant: u
  } = a, x = {
    root: ["root", `size${j(b)}`, u, y, e !== "standard" && `${u}${j(e)}`, s && "disabled", f && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[r]],
    icon: ["icon"]
  };
  return S(x, na, t);
}, ca = T("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: q
})(({
  theme: a,
  ownerState: t
}) => l({}, a.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (a.vars || a).palette.text.primary,
  height: "auto",
  [`&.${p.disabled}`]: {
    opacity: (a.vars || a).palette.action.disabledOpacity
  }
}, t.size === "small" && {
  minWidth: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, t.size === "large" && {
  minWidth: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: a.typography.pxToRem(15)
})), pa = T(ta, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: q
})(({
  theme: a,
  ownerState: t
}) => l({}, a.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (a.vars || a).palette.text.primary,
  [`&.${p.focusVisible}`]: {
    backgroundColor: (a.vars || a).palette.action.focus
  },
  [`&.${p.disabled}`]: {
    opacity: (a.vars || a).palette.action.disabledOpacity
  },
  transition: a.transitions.create(["color", "background-color"], {
    duration: a.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (a.vars || a).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${p.selected}`]: {
    backgroundColor: (a.vars || a).palette.action.selected,
    "&:hover": {
      backgroundColor: a.vars ? `rgba(${a.vars.palette.action.selected} / calc(${a.vars.palette.action.selectedOpacity} + ${a.vars.palette.action.hoverOpacity}))` : I(a.palette.action.selected, a.palette.action.selectedOpacity + a.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (a.vars || a).palette.action.selected
      }
    },
    [`&.${p.focusVisible}`]: {
      backgroundColor: a.vars ? `rgba(${a.vars.palette.action.selected} / calc(${a.vars.palette.action.selectedOpacity} + ${a.vars.palette.action.focusOpacity}))` : I(a.palette.action.selected, a.palette.action.selectedOpacity + a.palette.action.focusOpacity)
    },
    [`&.${p.disabled}`]: {
      opacity: 1,
      color: (a.vars || a).palette.action.disabled,
      backgroundColor: (a.vars || a).palette.action.selected
    }
  }
}, t.size === "small" && {
  minWidth: 26,
  height: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, t.size === "large" && {
  minWidth: 40,
  height: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: a.typography.pxToRem(15)
}, t.shape === "rounded" && {
  borderRadius: (a.vars || a).shape.borderRadius
}), ({
  theme: a,
  ownerState: t
}) => l({}, t.variant === "text" && {
  [`&.${p.selected}`]: l({}, t.color !== "standard" && {
    color: (a.vars || a).palette[t.color].contrastText,
    backgroundColor: (a.vars || a).palette[t.color].main,
    "&:hover": {
      backgroundColor: (a.vars || a).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (a.vars || a).palette[t.color].main
      }
    },
    [`&.${p.focusVisible}`]: {
      backgroundColor: (a.vars || a).palette[t.color].dark
    }
  }, {
    [`&.${p.disabled}`]: {
      color: (a.vars || a).palette.action.disabled
    }
  })
}, t.variant === "outlined" && {
  border: a.vars ? `1px solid rgba(${a.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${a.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
  [`&.${p.selected}`]: l({}, t.color !== "standard" && {
    color: (a.vars || a).palette[t.color].main,
    border: `1px solid ${a.vars ? `rgba(${a.vars.palette[t.color].mainChannel} / 0.5)` : I(a.palette[t.color].main, 0.5)}`,
    backgroundColor: a.vars ? `rgba(${a.vars.palette[t.color].mainChannel} / ${a.vars.palette.action.activatedOpacity})` : I(a.palette[t.color].main, a.palette.action.activatedOpacity),
    "&:hover": {
      backgroundColor: a.vars ? `rgba(${a.vars.palette[t.color].mainChannel} / calc(${a.vars.palette.action.activatedOpacity} + ${a.vars.palette.action.focusOpacity}))` : I(a.palette[t.color].main, a.palette.action.activatedOpacity + a.palette.action.focusOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${p.focusVisible}`]: {
      backgroundColor: a.vars ? `rgba(${a.vars.palette[t.color].mainChannel} / calc(${a.vars.palette.action.activatedOpacity} + ${a.vars.palette.action.focusOpacity}))` : I(a.palette[t.color].main, a.palette.action.activatedOpacity + a.palette.action.focusOpacity)
    }
  }, {
    [`&.${p.disabled}`]: {
      borderColor: (a.vars || a).palette.action.disabledBackground,
      color: (a.vars || a).palette.action.disabled
    }
  })
})), da = T("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (a, t) => t.icon
})(({
  theme: a,
  ownerState: t
}) => l({
  fontSize: a.typography.pxToRem(20),
  margin: "0 -8px"
}, t.size === "small" && {
  fontSize: a.typography.pxToRem(18)
}, t.size === "large" && {
  fontSize: a.typography.pxToRem(22)
})), J = /* @__PURE__ */ w.forwardRef(function(t, e) {
  const s = D({
    props: t,
    name: "MuiPaginationItem"
  }), {
    className: f,
    color: b = "standard",
    component: y,
    components: r = {},
    disabled: u = !1,
    page: x,
    selected: O = !1,
    shape: M = "circular",
    size: m = "medium",
    slots: c = {},
    type: i = "page",
    variant: B = "text"
  } = s, z = U(s, ra), g = l({}, s, {
    color: b,
    disabled: u,
    selected: O,
    shape: M,
    size: m,
    type: i,
    variant: B
  }), N = aa(), v = la(g), $ = (N.direction === "rtl" ? {
    previous: c.next || r.next || V,
    next: c.previous || r.previous || F,
    last: c.first || r.first || W,
    first: c.last || r.last || A
  } : {
    previous: c.previous || r.previous || F,
    next: c.next || r.next || V,
    first: c.first || r.first || W,
    last: c.last || r.last || A
  })[i];
  return i === "start-ellipsis" || i === "end-ellipsis" ? /* @__PURE__ */ d.jsx(ca, {
    ref: e,
    ownerState: g,
    className: E(v.root, f),
    children: "…"
  }) : /* @__PURE__ */ d.jsxs(pa, l({
    ref: e,
    ownerState: g,
    component: y,
    disabled: u,
    className: E(v.root, f)
  }, z, {
    children: [i === "page" && x, $ ? /* @__PURE__ */ d.jsx(da, {
      as: $,
      ownerState: g,
      className: v.icon
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (J.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'standard'
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "standard"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: o.shape({
    first: o.elementType,
    last: o.elementType,
    next: o.elementType,
    previous: o.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * The current page number.
   */
  page: o.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: o.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: o.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    first: o.elementType,
    last: o.elementType,
    next: o.elementType,
    previous: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: o.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: o.oneOfType([o.oneOf(["outlined", "text"]), o.string])
});
const ua = J, ga = ["boundaryCount", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"], va = (a) => {
  const {
    classes: t,
    variant: e
  } = a;
  return S({
    root: ["root", e],
    ul: ["ul"]
  }, oa, t);
}, fa = T("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (a, t) => {
    const {
      ownerState: e
    } = a;
    return [t.root, t[e.variant]];
  }
})({}), ba = T("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (a, t) => t.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function ya(a, t, e) {
  return a === "page" ? `${e ? "" : "Go to "}page ${t}` : `Go to ${a} page`;
}
const K = /* @__PURE__ */ w.forwardRef(function(t, e) {
  const s = D({
    props: t,
    name: "MuiPagination"
  }), {
    boundaryCount: f = 1,
    className: b,
    color: y = "standard",
    count: r = 1,
    defaultPage: u = 1,
    disabled: x = !1,
    getItemAriaLabel: O = ya,
    hideNextButton: M = !1,
    hidePrevButton: m = !1,
    renderItem: c = (P) => /* @__PURE__ */ d.jsx(ua, l({}, P)),
    shape: i = "circular",
    showFirstButton: B = !1,
    showLastButton: z = !1,
    siblingCount: g = 1,
    size: N = "medium",
    variant: v = "text"
  } = s, L = U(s, ga), {
    items: $
  } = sa(l({}, s, {
    componentName: "Pagination"
  })), R = l({}, s, {
    boundaryCount: f,
    color: y,
    count: r,
    defaultPage: u,
    disabled: x,
    getItemAriaLabel: O,
    hideNextButton: M,
    hidePrevButton: m,
    renderItem: c,
    shape: i,
    showFirstButton: B,
    showLastButton: z,
    siblingCount: g,
    size: N,
    variant: v
  }), h = va(R);
  return /* @__PURE__ */ d.jsx(fa, l({
    "aria-label": "pagination navigation",
    className: E(h.root, b),
    ownerState: R,
    ref: e
  }, L, {
    children: /* @__PURE__ */ d.jsx(ba, {
      className: h.ul,
      ownerState: R,
      children: $.map((P, n) => /* @__PURE__ */ d.jsx("li", {
        children: c(l({}, P, {
          color: y,
          "aria-label": O(P.type, P.page, P.selected),
          shape: i,
          size: N,
          variant: v
        }))
      }, n))
    })
  }));
});
process.env.NODE_ENV !== "production" && (K.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: k,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'standard'
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "standard"]), o.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: k,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: k,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: o.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: o.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: o.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: o.func,
  /**
   * The current page.
   */
  page: k,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: o.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: o.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: o.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: o.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: k,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: o.oneOfType([o.oneOf(["outlined", "text"]), o.string])
});
const xa = K, Ra = T(
  ma
)(({ theme: a }) => ({
  [`.${p.root}`]: {
    ...a.typography.overline1,
    //Workaround since Typography(PaginationItem) component's variant prop is not working
    color: a.palette.blue.c100,
    "&.Mui-selected, &.Mui-selected:hover": {
      color: a.palette.common.white,
      backgroundColor: a.palette.blue.c100
    },
    "&.Mui-disabled": {
      visibility: "hidden"
    }
  }
}));
function ma(a) {
  return /* @__PURE__ */ Y.createElement(xa, { ...a });
}
export {
  Ra as M
};
